import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getUserTagsForSuite = async (testSuiteREsultId) => {
  const userDetail = localStorage.getItem("userDetail");
  if (!userDetail) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetail);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getAllTagsForSuiteResult&companyid=${user.companyid}&testSuiteResultId=${testSuiteREsultId}`,
  );

  return response.data;
};

const useGetUserTagsForSuiteQuery = (testSuiteREsultId, options) => {
  return useQuery({
    queryKey: ["userTags", testSuiteREsultId],
    queryFn: () => getUserTagsForSuite(testSuiteREsultId),
    ...options,
    staleTime: 0,
  });
};

export default useGetUserTagsForSuiteQuery;
